(function(){
    'use strict';

    angular
    .module('appback')
    .controller('PedidosController', PedidosController)
 
    PedidosController.$inject = ["$scope","PedidosService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce","$window"];
              
    function PedidosController($scope,PedidosService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce,$window)
    {                         
        var vm = this;
        console.log("PedidoController");

        vm.proveedor_id = "";
        vm.proveedor = {};
        vm.productosProveedor = [];
        vm.pedido = [];
        vm.precioPedido = 0;
        vm.observaciones_pedido = "";
        vm.pedidoActivoID = 0;
        vm.pedidoActivo = false;
        vm.tabActive = "general";
        vm.generalLab = GenerallabService;

        vm.material_id = "";
        vm.num_orden = "";
        vm.last_proveedor_id = 0;
        vm.kits_a_preparar = 1;
        vm.pruebaRepeat = [{nombre:"hola"},{nombre:"adios"}];
        vm.enableBtns = false;
        vm.zeroStart = 0;
        vm.material_idsetTochart ='';
        vm.pedidosActivos = [];
        vm.pedidoEnCurso =false
        vm.pedidoTransporteEnCurso = {coste:"",fecha:""};
        vm.pedidoAccion = {accion:""};
        vm.filtroestado = "";
        vm.filtrodireccion = "ASC";
        vm.filtroorden = "";
        vm.toastclass='';
        vm.toastshow=false;
        vm.toastMsg = "";
        vm.acciones = {expanded:true}
        vm.spinneractivo = true
        vm.producto_a_comprar_objetivo = false;
        vm.puedeCerrarPedido = true;

        vm.reset = function(){
            vm.pedido = [];
            vm.precioPedido = 0;
            vm.observaciones_pedido = "";
            vm.getProductosProveedor();
        }


        vm.getProductosProveedor = function(){
            if(vm.proveedor_id){
                console.log("getProductosProveedor proveedor_id: ",vm.proveedor_id);
                PedidosService.getProductosByProveedor(vm.proveedor_id,function(data){
                    console.log("data getProductosProveedor",data);
                    vm.proveedor = data.proveedor;
                    vm.productosProveedor = data.productosproveedor;
                    vm.initProductos();
                });
            }
        }

        vm.initProductos = function() {
            vm.productosProveedor.sort(function(a, b) {
                if (a.material.referencia < b.material.referencia) return -1;
                if (a.material.referencia > b.material.referencia) return 1;
                return 0;
            });
            vm.productosProveedor.forEach(function(producto) {
                producto.cantidad_seleccionada = 1;
                producto.cantidad = 0;
            })
        }

        vm.decrementQuantity = function(producto) {
            if (producto.cantidad > 1) {
                producto.cantidad--;
            }
        };
        
        vm.incrementQuantity = function(producto) {
            producto.cantidad++;
        };

        vm.addProducto = function(producto){
            console.log("producto", producto);
            var found = false;
        	for(var cont=0;cont<vm.pedido.length && !found;cont++){
        		if(producto.id==vm.pedido[cont].id){
                    producto.cantidad = parseFloat(vm.pedido[cont].cantidad) + parseFloat(producto.cantidad_seleccionada);
                    vm.pedido[cont].cantidad = producto.cantidad;
                    found = true;
        		}
        	}
            if(!found){
                producto.cantidad = producto.cantidad_seleccionada;
                vm.pedido.push(producto);
            }
            producto.cantidad_seleccionada = 1;
        }

        vm.removeMaterial = function(producto){
            var index = -1;
            for(var cont=0; cont<vm.pedido.length; cont++){
                if(producto.id == vm.pedido[cont].id){
                    index = cont;
                    break;
                }
            }
            if(index > -1){
                producto.cantidad = 0;
                vm.pedido.splice(index, 1);
            }
        }

        vm.calcularCarrito = function(){
            console.log("calculando carrito", vm.pedido);
            vm.precioPedido = 0;
            for(var cont=0;cont<vm.pedido.length;cont++){
                vm.precioPedido += vm.pedido[cont].precioproducto * vm.pedido[cont].cantidad;
            }
            console.log("preico del carrito", vm.precioPedido);
        }

        vm.cerrarCarrito =  function () {
            console.log("finalizando pedido", vm.pedido);
            PedidosService.crearPedido(vm.proveedor_id, vm.pedido, vm.observaciones_pedido,function(data){
                console.log('data tras set', data)
                if(data.code>0) {
                    vm.reset();
                    vm.showtoast('Pedido Creado');
                    window.location = "/backend/pedidos/viewpedido?pedido_id=" + data.id_pedido;
                } else {
                    vm.showtoast('Algo falló');
                }
            });
            
        }

        vm.getPedido = function(){
            console.log('buscarPedido', vm.pedidoActivoID)
            PedidosService.getPedido(vm.pedidoActivoID,function(data){
                vm.pedidoActivo = data.pedido;
                console.log("data getPedido ",vm.pedidoActivo);
            })
        }

        vm.popupAcciones = "";
        vm.btnAcciones = function(){
          console.log("BTNACCIONES");
           vm.popupAcciones = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              //windowClass: 'modal-danger',
              //backdrop  : 'static',
              templateUrl: '/backend/pedidos/template?name=acciones.twig',
              size: 'lg',
              controller: function($scope) {
                $scope.pedidoid = vm.pedidoActivoID;
                $scope.acciones = vm.pedidoActivo.acciones;
                $scope.pedidoactivo = vm.pedidoActivo;
                console.log("controller acciones", $scope);
                $scope.okForm = function(){
                   vm.popupAcciones.close();
                }
                $scope.koForm = function(){
                    vm.popupAcciones.close();
                }
              }
            });
        }


       
        vm.buscarPedidosPendientes = function(){
            
            let params = {
                filtroestado:vm.filtroestado,
                filtrodireccion:vm.filtrodireccion,
                filtroproveedor:vm.proveedor_id,
                filtroorden:vm.filtroorden
            }
            console.log('buscarPedidosPendientes',params)
            PedidosService.getPedidosPendientes(params,function(data){
            
                vm.pedidosActivos = data.pedidospendientes;
                console.log("data getPedidosPendientes",data,vm.pedidosActivos);
            })
        }

        vm.pedidoComprobarMinimos = function(){
            vm.puedeCerrarPedido = true;
            var msgComprobacion = [];
            console.log('pedidoComprobarMinimos',vm.pedidoEnCurso.lineasPedido);
            if (angular.isDefined(vm.pedidoEnCurso.lineasPedido)
            && angular.isDefined(vm.pedidoEnCurso.lineasPedido.length)) {
                for(var cont = 0; cont<vm.pedidoEnCurso.lineasPedido.length;cont++){
                    if(vm.pedidoEnCurso.lineasPedido[cont].cantidad< vm.pedidoEnCurso.lineasPedido[cont].minimo_requerido) {
                        vm.puedeCerrarPedido = false;
                        // Podría ser un array
                        msgComprobacion.push('Debe comprar al menos ' + vm.pedidoEnCurso.lineasPedido[cont].minimo_requerido + ' del producto ' +vm.pedidoEnCurso.lineasPedido[cont].productoacomprar.nombre + ' para continuar con el pedido');
                    }
                }
            }
            console.log(msgComprobacion.length);
            // >No me gusta mucho, prefferiria que los mensajes se vieran en cascada
            if (msgComprobacion.length > 0) {
                var msgToShow = '';
                msgComprobacion.forEach(msgTo => {
                    if (msgToShow == '') {
                        msgToShow = msgTo;

                    } else {
                        msgToShow = msgToShow +'\n'+ msgTo;
                    }
                    
                })
                
                vm.showtoast(msgToShow);
            }
        }
        vm.pedidoComprobarFranjasDePrecio = function(linea_pedido){
            console.log('pedidoComprobarFranjasDePrecio',linea_pedido)
            if (angular.isDefined(linea_pedido.franjas_de_precio) 
            && linea_pedido.franjas_de_precio.length > 0) {
                linea_pedido.precioproducto = linea_pedido.defaultprecioproducto;
                for(var cont = 0; cont<linea_pedido.franjas_de_precio.length;cont++){
                    if( parseFloat(linea_pedido.franjas_de_precio[cont].from) <= parseFloat(linea_pedido.cantidad)) {
                        // console.log('Franja encontrada',linea_pedido.franjas_de_precio[cont].from, 'cantidad:',linea_pedido.cantidad)
                        linea_pedido.precioproducto = linea_pedido.franjas_de_precio[cont].precio;
                    }
                }
            }

        }
        vm.finalizarPedido =  function () {
            console.log(vm.pedidosActivos)
            let params = {
                pedido_id:vm.pedidoActivo.id
            }
            console.log('finalizarPedido',params);
            PedidosService.finalizarPedido(params,function(data){
                console.log('data tras set', data)
                if (!data?.error) {
                    // vm.pedidosActivos = [];
                    vm.showtoast('Linea actualziada')
                } else {
                    vm.showtoast('Algo falló')
                }
                vm.pedidosActivos = [];
                // vm.pedidoActivo = data.pedido;
                window.location = "/backend/altcrm/content?ContentSearch[node_type]=pedidos";
            });
            
        }
        // Estas funciones quizá deban estar encapsuladas para que sean usadas desde cualquier controlador
        vm.isFloat =  function(n) {
            // return n === +n && n !== (n|0);
            return n != "" && !isNaN(n) && Math.round(n) != n;
        }
        
        vm.isInteger = function(n) {
            return n != "" && !isNaN(n) && Math.round(n) == n;
        }
        
        vm.showtoast = function(msg) {
            console.log('showtoast')
            vm.toastMsg = msg;
            vm.toastclass = 'show';
            $timeout(function(){ 
                vm.toastclass = 'invisible';
                vm.toastMsg = '';
            }, 3000);
        }
    }
  
})();
